<template>
	<table class="table table--small">
		<thead>
			<tr>
				<th class="text-left">Description</th>
				<th class="text-right">Value</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="detail in details" :key="detail._id">
				<td>{{ getDescription(detail) }}</td>
				<td class="text-right">
					<b
						:class="detail.mutation === 'credit' ? 'text-success' : 'text-danger'"
						>{{ formatNumber(detail.value) }}</b
					>
				</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
import {
	formatNumberPlain,
	getPaymentChannelLabel,
	toTitleCase,
} from '@/lib/helper';

const TYPES = {
	TOTAL: 'total',
	TRANSACTION_FEE: 'transaction_fee',
	TRANSACTION_FEE_TAX: 'transaction_fee_tax',
	SHIPPING_COST: 'shipping_cost',
	COMMISSION: 'commission',
	MARGIN: 'margin',
	OUTSOURCE_PAYMENT: 'outsource_payment',
	OUTSOURCE_COMMISSION: 'outsource_commission',
	HANDLING_FEE: 'handling_fee',
	CREDIT_OSTOCK_PRIVATE_ORDER_TYPE: 'revenue_product',
	CREDIT_SUPPLIER_PRIVATE_ORDER_TYPE: 'payment_product_wholesale',
};

export default {
	name: 'StashDetails',
	props: {
		details: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		formatNumber(value) {
			return formatNumberPlain(value);
		},
		getDescription(detail) {
			const detailType = detail.type || '';
			let type = detailType.replaceAll('_', ' ');
			type = toTitleCase(type);
			if (detailType === TYPES.TRANSACTION_FEE) {
				const channel = detail?.data?.channel ?? '';
				const percentageFee = detail?.data?.fee?.percentage ?? 0;
				const fixedFee = detail?.data?.fee?.fixed ?? 0;
				const channelLabel = getPaymentChannelLabel(channel);
				const fees = [];
				if (percentageFee > 0) {
					const percentageFeeString = `${percentageFee}%`;
					fees.push(percentageFeeString);
				}
				if (fixedFee > 0) {
					const fixedFeeString = `Rp${fixedFee}`;
					fees.push(fixedFeeString);
				}
				let feeLabel = fees.join(' + ');
				feeLabel += '/transaction';
				type = `${type} ${feeLabel} via ${channelLabel}`;
			} else if (detailType === TYPES.TRANSACTION_FEE_TAX) {
				const tax = detail?.data?.percentage ?? 0;
				const taxLabel = `${tax}%`;
				type = `${type} ${taxLabel}`;
			} else if (detailType === TYPES.COMMISSION) {
				const product = detail?.data?.product?.name ?? '';
				if (product !== '') {
					type = `Reseller ${type} product "${product}"`;
				} else {
					type = `Reseller ${type}`;
				}
			} else if (detailType === TYPES.MARGIN) {
				const product = detail?.data?.product?.name ?? '';
				if (product !== '') {
					type = `Margin Reseller from product "${product}"`;
				} else {
					type = 'Margin Reseller';
				}
			} else if (detailType === TYPES.OUTSOURCE_PAYMENT) {
				const product = detail?.data?.name ?? '';
				const quantity = detail?.data?.quantity ?? '';
				if (product !== '' && quantity !== '') {
					type = `Payment from product "${product} (x${quantity})"`;
				} else {
					type = 'Payment Product';
				}
			} else if (detailType === TYPES.OUTSOURCE_COMMISSION) {
				const product = detail?.data?.name ?? '';
				const quantity = detail?.data?.quantity ?? '';
				if (product !== '' && quantity !== '') {
					type = `Commission from product "${product} (x${quantity})"`;
				} else {
					type = 'Commission Product';
				}
			} else if (detailType === TYPES.HANDLING_FEE) {
				type = detail?.description;
			} else if (detailType === TYPES.CREDIT_OSTOCK_PRIVATE_ORDER_TYPE || detailType === TYPES.CREDIT_SUPPLIER_PRIVATE_ORDER_TYPE) {
				type = detail?.description;
			}

			return type;
		},
	},
};
</script>
